"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BlockType;
(function (BlockType) {
    BlockType["Accordion"] = "Accordion";
    BlockType["AccordionField"] = "AccordionField";
    BlockType["AccordionHeader"] = "AccordionHeader";
    BlockType["AccordionBody"] = "AccordionBody";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
